export default __webpack_public_path__ + "static/404-3-4a91a10bae2b3e738e8f9c35ca044c03.jpg";